import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { PublisherForTable } from '../../types'
import { publisherForTableFromDTO } from './api/mapper'
import { GET_PUBLISHERS_FOR_TABLE } from './api/query'
import { Data, PublisherForTableDTO, Variables } from './api/types'
import { UseGetPublishers, UseGetPublishersProps } from './types'

export const useGetPublishers = ({
  filters,
  first,
  last,
}: UseGetPublishersProps): UseGetPublishers => {
  const [users, setUsers] = useState<PublisherForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const {
        users: { nodes: users, totalCount: count },
      } = data

      if (users) {
        setUsers(
          users.map(
            (user: PublisherForTableDTO): PublisherForTable => publisherForTableFromDTO(user),
          ),
        )
        setCount(count)
      }
    },
    query: GET_PUBLISHERS_FOR_TABLE,
    variables: {
      first,
      last,
      terms: filters,
      userGroup: 'publishers',
    },
  })

  return {
    count,
    loading: isLoading,
    users,
  }
}
